import { notification } from "antd"
import { useLazyGetExternalClientCellsQuery } from "features/shared/api"
import { useQueryUpdate } from "hooks/useQueryUpdate"
import { t } from "i18next"
import { Button, Skeleton } from "../../common"

const ShowNumber = ({ data, form, conditionalComponent = () => <></>, formFieldName, from, fetchingLeadDetails }) => {
  const [getExternalClientInfo, { data: externalCells, isFetching: fetchExternalClientCell }] =
    useLazyGetExternalClientCellsQuery()

  const [update] = useQueryUpdate()

  const fetchClientCell = () => {
    getExternalClientInfo(data)
      .unwrap()
      .then(e => {
        form.setFieldsValue({ [formFieldName]: e[0] })
        update("getExternalClientCells", () => null, null, data)
      })
      .catch(e => {
        notification.error({ message: e.message })
      })
  }

  return fetchingLeadDetails ? (
    <Skeleton type="input" />
  ) : !form.getFieldValue(formFieldName)?.[3] && (from === "edit" || from === "fetch") ? (
    <div className="mbe-24">
      <Button loading={fetchExternalClientCell} type={"primary-light"} onClick={fetchClientCell}>
        {t("Show client phone number")}
      </Button>
    </div>
  ) : (
    <>{conditionalComponent(form.getFieldValue("status"))}</>
  )
}

export default ShowNumber
